import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';

import {Provider} from 'react-redux';

import 'styles/semantic.less';
import 'styles/gmm.scss';
import {ConnectedRouter} from 'react-router-redux';
import {Route, Switch} from 'react-router-dom';
import AuthRoutes from 'go/authRoutes';
import Login from 'go/pages/login';
import CreateNewAccount from 'go/pages/account/registration/CreateNewAccount';
import RequestPasswordReset from 'go/pages/account/password/RequestPasswordReset';
import UnauthAccount from 'go/pages/account/registration/UnauthAccount';
import ProvideProfileInfo from 'go/pages/account/registration/ProvideProfileInfo';
import PageWrapper from 'go/components/layout/PageWrapper';
import EventSourceController from 'go/components/events/EventSourceController';
import {userIsAuthenticatedRedir} from 'go/components/authHOC';
import TimeoutModal from 'go/components/auth/timeoutModal';
import IdleTimer from 'go/components/auth/idleTimerWrapper';
import {Toggle, ToggleGate, TokenGate} from 'componentLibrary';
import {FetchErrorInterceptor} from 'app-ui-componentlibrary';
import ConcurrentEditingWrapper from 'go/components/concurrency/concurrentEditingWrapper';
import {history} from 'app-ui-componentlibrary/dist/common/constants';
import goStore from 'go/store'; // redux store is now initialized here

const RootPage = (props) => {
  return (
    <ToggleGate>
      <IdleTimer />
      <TimeoutModal />
      <ConcurrentEditingWrapper />
      <Toggle toggle="disableSSE" ifNot>
        <EventSourceController />
      </Toggle>
      <Toggle toggle="fetchErrorInterceptor">
        <FetchErrorInterceptor />
      </Toggle>
      <TokenGate>
        <ConnectedRouter history={history}>
          <Switch>
            <Route
              exact
              path="/login"
              render={(props) => <PageWrapper {...props} pageType={Login} />}
            />
            <Route
              exact
              path="/register"
              render={(props) => <PageWrapper {...props} pageType={CreateNewAccount} />}
            />
            <Route
              exact
              path="/requestPasswordReset"
              render={(props) => (
                <PageWrapper {...props} pageType={RequestPasswordReset} />
              )}
            />
            <Route
              exact
              path="/createPW"
              render={(props) => (
                <PageWrapper {...props} pageType={UnauthAccount} createNewPass={true} />
              )}
            />
            <Route
              exact
              path="/addUserInfo"
              render={(props) => (
                <Toggle toggle="loginGovIntegration">
                  <PageWrapper {...props} pageType={ProvideProfileInfo} />
                </Toggle>
              )}
            />

            <Route
              exact
              path="/updatePW"
              render={(props) => (
                <PageWrapper {...props} pageType={UnauthAccount} createNewPass={false} />
              )}
            />
            <Route component={userIsAuthenticatedRedir(AuthRoutes)} />
          </Switch>
        </ConnectedRouter>
      </TokenGate>
    </ToggleGate>
  );
};

ReactDOM.render(
  <Provider store={goStore.store}>
    <RootPage />
  </Provider>,
  document.getElementById('root')
);
